import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 1.75rem;
`
